import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';
const IconEnergy = ({ width = '16', height = '16', viewBox = '0 0 16 16', color = colors.deionizerBlack }) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <g clipPath='url(#clip0_13148_67767)'>
            <path d='M12.9 6.98C12.51 5.04 10.94 3.47 9 3.1C8.66 3.03 8.33 3 8 3C5.24 3 3 5.24 3 8C3 9.63 3.79 11.09 5 12V15C5 15.55 5.45 16 6 16H10C10.55 16 11 15.55 11 15V12C12.46 10.9 13.31 9.01 12.9 6.98ZM10.1 10.8L9.5 11.25V13H6.5V11.25L5.9 10.8C5.02 10.14 4.5 9.09 4.5 8C4.5 6.07 6.07 4.5 8 4.5C8.23 4.5 8.47 4.52 8.71 4.57C10.04 4.83 11.16 5.94 11.43 7.28C11.7 8.63 11.19 9.98 10.1 10.8ZM8.75 2H7.25V0H8.75V2ZM2 9.25H0V7.75H2V9.25ZM3.13 4.19L1.72 2.78L2.78 1.72L4.19 3.13L3.13 4.19ZM12.86 4.19L11.8 3.13L13.21 1.72L14.27 2.78L12.86 4.19ZM15.99 9.25H13.99V7.75H15.99V9.25Z' fill={color} />
        </g>
        <defs>
            <clipPath id='clip0_13148_67767'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>;
IconEnergy.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    viewBox: PropTypes.string
};
export default React.memo(IconEnergy);
